// Every storefront form that sends to the +Bake inbox (contact, colab, catering
// quote) must post here, never to /medusa/store/contact.
//
// /api/contact runs Vercel BotID's checkBotId() and treats any request without
// a BotID token as a bot. The browser only attaches that token to paths listed
// in lib/utils/botid-client.ts, which reads this same constant — so a form that
// posts anywhere else is rejected with a 403 in production for every real user.
export const CONTACT_ENDPOINT = "/api/contact"

type ContactErrorBody = { message?: string } | null

export async function submitContactForm(
  body: Record<string, unknown>,
): Promise<void> {
  const response = await fetch(CONTACT_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })

  if (!response.ok) {
    const detail = (await response
      .json()
      .catch(() => null)) as ContactErrorBody
    throw new Error(detail?.message || "An unknown error occurred.")
  }
}
